import { render, staticRenderFns } from "./EventHistoryMobile.vue?vue&type=template&id=642c10b5&scoped=true&"
import script from "./EventHistoryMobile.vue?vue&type=script&lang=js&"
export * from "./EventHistoryMobile.vue?vue&type=script&lang=js&"
import style0 from "./EventHistoryMobile.vue?vue&type=style&index=0&id=642c10b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642c10b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCalendar } from 'vuetify/lib/components/VCalendar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataIterator } from 'vuetify/lib/components/VDataIterator';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VBtnToggle,VCalendar,VCard,VCardText,VChip,VCol,VDataIterator,VDataTable,VDialog,VIcon,VLayout,VList})
